import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReceiptModal from './receipt-modal'
import USD from '../usd'

const Cart = props => {
  const [receiptShown, setReceiptShown] = useState(false)
  const { transaction, percentDiscount, discount, currency } = props

  let netAmount = 0
  let taxAmount = 0

  const items = transaction.items.map((item, i) => {
    netAmount += item.netAmount * percentDiscount
    taxAmount += item.netAmount * item.taxRate * percentDiscount
    return (
      <tr className='transaction-cart__item' key={i}>
        <td>{item.quantity} {item.name}</td>
        <td><USD val={item.netAmount}/></td>
      </tr>
    )
  })

  const totalAmount = (netAmount + taxAmount)
  const discountAmount = discount.amount
  const discountPercentage = discount.percentage
  const currencyName = currency == 'usd' ? '' : ` (${currency.toUpperCase()})`
  const discountRows = [
    <tr key={1} className='transaction-cart__discount'>
      <td rowSpan='2'>Discount</td>
      <td className='transaction-cart__discount-amount'><USD val={parseFloat(discountAmount)}/></td>
    </tr>,
    <tr key={2}>
      <td className='transaction-cart__discount-percentage'>{discountPercentage}%</td>
    </tr>
  ]

  return (
    <div className='transaction-cart'>
      <div className='transaction-cart__title'>
        <div className='transaction-cart__header'>Sale</div>
        <div className='transaction-cart__receipt'>
          {transaction.id && <a
            className='transaction-cart__receipt-link'
            href='#'
            onClick={e => setReceiptShown(true)} />}
        </div>
      </div>
      <table className='transaction-cart__items'>
        <tbody>
        {items}
        <tr></tr>
        {discountPercentage != 0 && discountRows}
        <tr className='transaction-cart__tax'>
          <td>Tax</td>
          <td className='transaction-cart__tax-amount'><USD val={taxAmount}/></td>
        </tr>
        </tbody>
      </table>
      <div className='transaction-cart__footer'>{`Total${currencyName} `}<USD val={totalAmount}/></div>
      <button className='transactions-history_button'
        style={{margin: 0, width: '15rem', position: 'absolute', top: '39rem', left: '2vh'}}
        onClick={props.toggleBatchReport}
        disabled={props.batchReportDisabled}>
        {props.displayBatchReport ? 'Hide Batch Report' : 'Show Batch Report'}
      </button>
      {receiptShown && <ReceiptModal
        receiptId={transaction.id}
        onClose={e => setReceiptShown(false)} />
      }
    </div>
  )
}

Cart.propTypes = {
  transaction: PropTypes.object.isRequired,
  displayBatchReport: PropTypes.bool.isRequired,
  batchReportDisabled: PropTypes.bool.isRequired
}

export default Cart
